import { useMemo, useState } from "react";

import { formatBps, formatCents } from "../../utils/directorFormat";

const compare = (left, right, key) => {
  if (key === "displayName") {
    return String(left.displayName ?? "").localeCompare(String(right.displayName ?? ""));
  }
  return (left[key] ?? 0) - (right[key] ?? 0);
};

const CustomerReceiptsTable = ({ companyId = null, items = [], onOpenCustomer }) => {
  const [sort, setSort] = useState({ key: "displayName", direction: "asc" });
  const sorted = useMemo(() => [...items].sort((left, right) => {
    const value = compare(left, right, sort.key);
    return (sort.direction === "asc" ? value : -value)
      || left.customerRef.localeCompare(right.customerRef);
  }), [items, sort]);
  const changeSort = (key) => setSort((current) => ({
    key,
    direction: current.key === key && current.direction === "asc" ? "desc" : "asc",
  }));
  const header = (key, label) => <button
    aria-label={`Ordenar por ${label}`}
    className="director-receivables-sort"
    onClick={() => changeSort(key)}
    type="button"
  >
    {label}
  </button>;
  const ariaSort = (key) => (
    sort.key === key ? (sort.direction === "asc" ? "ascending" : "descending") : "none"
  );
  const companyQuery = companyId
    ? `?company_id=${encodeURIComponent(companyId)}`
    : "";

  return <div className="director-table-scroll">
    <table aria-label="Clientes e unidades" className="director-table director-receivables-table">
      <thead>
        <tr>
          <th aria-sort={ariaSort("displayName")} scope="col">{header("displayName", "Cliente")}</th>
          <th aria-sort={ariaSort("unitCount")} scope="col">{header("unitCount", "Unidades")}</th>
          <th aria-sort={ariaSort("contractedAmountCents")} scope="col">{header("contractedAmountCents", "Contratado")}</th>
          <th aria-sort={ariaSort("receivedAmountCents")} scope="col">{header("receivedAmountCents", "Recebido")}</th>
          <th aria-sort={ariaSort("receivedPctBps")} scope="col">{header("receivedPctBps", "% pago")}</th>
        </tr>
      </thead>
      <tbody>
        {sorted.map((item) => <tr key={item.customerRef}>
          <th scope="row">
            <a
              aria-label={`Abrir ${item.displayName || "cliente"}`}
              href={`/dashboard/director/customer-receipts/${encodeURIComponent(item.customerRef)}${companyQuery}`}
              onClick={(event) => {
                event.preventDefault();
                onOpenCustomer?.(item.customerRef);
              }}
            >
              {item.displayName || "Cliente sem nome disponível"}
            </a>
          </th>
          <td>{Number.isSafeInteger(item.unitCount) ? item.unitCount : "—"}</td>
          <td>{formatCents(item.contractedAmountCents)}</td>
          <td>{formatCents(item.receivedAmountCents)}</td>
          <td>{formatBps(item.receivedPctBps)}</td>
        </tr>)}
      </tbody>
    </table>
  </div>;
};

export default CustomerReceiptsTable;
